export function Extraction(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2 6.49999C16.2 5.83725 15.6628 5.29999 15 5.29999H7.00005C6.33731 5.29999 5.80005 5.83725 5.80005 6.49999C5.80005 7.16273 6.33731 7.69999 7.00005 7.69999H15C15.6628 7.69999 16.2 7.16273 16.2 6.49999Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.60439 0.799988H16.3957C17.8955 0.799988 19.1941 1.84169 19.5195 3.30581L21.0762 10.311C21.1585 10.6814 21.2 11.0597 21.2 11.4391V18C21.2 19.7673 19.7674 21.2 18 21.2H4.00005C2.23274 21.2 0.800049 19.7673 0.800049 18V11.4391C0.800049 11.0597 0.841572 10.6814 0.923876 10.311L2.48059 3.30581C2.80595 1.84169 4.10456 0.799988 5.60439 0.799988ZM17.1767 3.82644L18.5132 9.84091C18.3461 9.81398 18.1747 9.79999 18 9.79999H4.00005C3.82537 9.79999 3.65397 9.81398 3.48689 9.84091L4.82344 3.82644C4.90478 3.46041 5.22943 3.19999 5.60439 3.19999H16.3957C16.7707 3.19999 17.0953 3.46041 17.1767 3.82644ZM3.20005 18V13C3.20005 12.5582 3.55822 12.2 4.00005 12.2H18C18.4419 12.2 18.8 12.5582 18.8 13V18C18.8 18.4418 18.4419 18.8 18 18.8H4.00005C3.55822 18.8 3.20005 18.4418 3.20005 18Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
